module.exports = __webpack_public_path__ + "img/3.86a238c4.jpg";